module.exports = __webpack_public_path__ + "templates.membership_reminder-bbccacb4.html";